"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
exports.default = vue_1.defineComponent({
    props: {
        data: {
            type: Object,
            default: function () { return ({}); },
        },
    },
    setup: function (props, ctx) {
        var data = vue_1.reactive({
            data: {},
        });
        vue_1.watchEffect(function () {
            data.data = props.data;
        });
        return __assign({}, vue_1.toRefs(data));
    },
});
